/**
 * Check whether a recommended trip can serve the passengers in the search.
 * @param {object} trip - Recommended trip to validate.
 * @param {object} searchPassengers - Passenger quantities keyed by category.
 * @returns {boolean} Whether the trip has enough availability.
 */
export const hasRecommendedTripAvailability = (trip, searchPassengers) => {
  if (!trip?.passengerTypes || !searchPassengers) return true;

  return trip.passengerTypes.every((passengerType) => {
    const requiredQuantity = searchPassengers[passengerType.type] || 0;
    const actualAvailability = Math.max(0, passengerType.availability);
    return actualAvailability >= requiredQuantity;
  });
};

/**
 * Remove recommended trips that cannot serve the requested passengers.
 * @param {Array} trips - Recommended trips to filter.
 * @param {object} searchPassengers - Passenger quantities keyed by category.
 * @returns {Array} Recommended trips with sufficient availability.
 */
export const filterRecommendedTripsByAvailability = (trips = [], searchPassengers) =>
  trips.filter((trip) => hasRecommendedTripAvailability(trip, searchPassengers));
